import { cn } from '@/utils/cn';
import {
  getChannelConfig,
  getChannelDisplayName,
  getChannelIconUrl,
  getChannelShortLabel,
} from '@/config/channels';

interface ChannelIconProps {
  channelId?: string | null;
  size?: number;
  className?: string;
}

export function ChannelIcon({ channelId, size = 18, className }: ChannelIconProps) {
  const iconUrl = getChannelIconUrl(channelId ?? undefined);
  const config = getChannelConfig(channelId ?? '');
  const title = getChannelDisplayName(channelId ?? undefined) || String(channelId || '');

  if (iconUrl) {
    return (
      <img
        src={iconUrl}
        alt=""
        title={title}
        width={size}
        height={size}
        className={cn('shrink-0 rounded object-contain', className)}
        aria-hidden
      />
    );
  }

  return (
    <span className={cn('leading-none', className)} title={title}>
      {config?.icon ?? '📡'}
    </span>
  );
}

interface ChannelNameProps {
  channelId?: string | null;
  label?: string;
  size?: number;
  short?: boolean;
  className?: string;
  iconClassName?: string;
}

/** Иконка канала + подпись (WABA / TG Bot / MAX / SMS …). */
export function ChannelName({
  channelId,
  label,
  size = 16,
  short = false,
  className,
  iconClassName,
}: ChannelNameProps) {
  const resolvedLabel =
    label ||
    (short ? getChannelShortLabel(channelId ?? undefined) : getChannelDisplayName(channelId ?? undefined)) ||
    String(channelId || '');

  return (
    <span
      className={cn('inline-flex min-w-0 items-center gap-1.5', className)}
      title={resolvedLabel}
    >
      <ChannelIcon channelId={channelId} size={size} className={iconClassName} />
      <span className="truncate">{resolvedLabel}</span>
    </span>
  );
}
